module.exports = __webpack_public_path__ + "static/media/img-icon.3add22a8.svg";